import ApiService from "./ApiService";

export async function apiSignInRequest(data) {
  return ApiService.fetchData({
    url: "/login",
    method: "post",
    data,
  });
}
